import { EventEmitter, Input, OnInit, Output, Directive } from "@angular/core";
import {IManagableObject} from "./IManagableObject";

@Directive()
export class BaseDialog implements OnInit{

  @Output() onSubmit: EventEmitter<any> = new EventEmitter();
  @Output() onOpen: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  @Input()
  public dialogId: string;
  public selectObjectsCount: number = 0;

  @Input()
  public objects: IManagableObject[] = [];


  public open(model:any) {
    this.onOpen.emit();
  }

  public close() {
    this.onClose.emit();
  }

  public submit() {
    this.onSubmit.emit();
  }


  public onToggleAll(value: boolean) {
    this.objects.forEach((command) => {
      if (command.CanSelect === false) return;
      command.IsChecked = value;
    });
    this.selectObjectsCount = this.objects.filter(c => c.IsChecked).length;
  }


  public onToggle(val: any) {
    this.selectObjectsCount = this.objects.filter(c => c.IsChecked).length;
  }

  ngOnInit(): void {
  }
}
